import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export const isByocPlanLimitExceedError = (error: unknown) => {
  return (
    error instanceof TmApiValidationError && error.message.includes('message limit') && error.message.includes('BYOC')
  )
}
